module.exports = __webpack_public_path__ + "static/media/feature-curate-share.74ebf796.png";